import { DestroyRef, Injectable, Signal, inject, signal } from '@angular/core';

export interface MemoryInfo {
  usedJSHeapSize: number;
  totalJSHeapSize: number;
  jsHeapSizeLimit: number;
  usedMB: number;
  totalMB: number;
  limitMB: number;
}

@Injectable({
  providedIn: 'root'
})
export class MemoryMonitorService {
  private readonly memoryUsage = signal<MemoryInfo | null>(null);
  private readonly intervalId: ReturnType<typeof setInterval>;

  readonly memory: Signal<MemoryInfo | null> = this.memoryUsage.asReadonly();

  constructor() {
    this.updateMemoryUsage();
    this.intervalId = setInterval(() => this.updateMemoryUsage(), 5000);

    inject(DestroyRef).onDestroy(() => clearInterval(this.intervalId));
  }

  private updateMemoryUsage() {
    if ('memory' in performance) {
      const memory = (performance as any).memory;
      this.memoryUsage.set({
        usedJSHeapSize: memory.usedJSHeapSize,
        totalJSHeapSize: memory.totalJSHeapSize,
        jsHeapSizeLimit: memory.jsHeapSizeLimit,
        usedMB: Math.round(memory.usedJSHeapSize / 1024 / 1024 * 100) / 100,
        totalMB: Math.round(memory.totalJSHeapSize / 1024 / 1024 * 100) / 100,
        limitMB: Math.round(memory.jsHeapSizeLimit / 1024 / 1024 * 100) / 100
      });
    }
  }

  logMemoryUsage() {
    if ('memory' in performance) {
      const memory = (performance as any).memory;
      console.log('Memory Usage:', {
        used: `${Math.round(memory.usedJSHeapSize / 1024 / 1024 * 100) / 100} MB`,
        total: `${Math.round(memory.totalJSHeapSize / 1024 / 1024 * 100) / 100} MB`,
        limit: `${Math.round(memory.jsHeapSizeLimit / 1024 / 1024 * 100) / 100} MB`
      });
    }
  }
}